<script setup>
import { inject, computed } from 'vue'
import { useVModel } from '#/general/useVModel'
import AppField from '#/general/AppField'
const { components, application, screen, global } = inject('Shared')
const props = defineProps([
  'value',
  'placeholder',
  'title',
  'name',
  'errors'
])
const emit = defineEmits(['update:value'])
const value = useVModel(props, 'value')

function input (event) {
  emit('update:value', event.target.value)
}

const errorMessage = computed(() => {
  if (props.errors) {
    const keys = Object.keys(props.errors)
    if (keys && keys.length > 0) {
      return props.errors[keys[0]]
    }
  }
  return null
})
</script>

<template lang="pug">
.us--contact-textarea
  .us--contact-textarea-title Nachricht
  app-field(:error-message="errorMessage" :hide-separator="true")
    textarea.us--contact-textarea-content(:placeholder="placeholder" v-model="value" :name="name")
</template>

<style lang="sass">
.us--contact-textarea
  max-width: 850px
  width: 100%
  @media screen and (min-width: 1024px)
    margin-top: 44px
  @media screen and (max-width: 1024px)
    margin-top: 44px
  .us--contact-textarea-title
    font-weight: 500
    line-height: 130%
    color: #22223C
    @media screen and (min-width: 1024px)
      font-size: 16px
      margin-bottom: 14px
      margin-left: 15px
    @media screen and (max-width: 1024px)
      font-size: 16px
      margin-bottom: 10px
      margin-left: 10px
  .us--contact-textarea-content
    width: 100%
    border: 1px solid #626C85
    border-radius: 5px
    font-weight: 500
    line-height: 130%
    color: #626C85
    height: 100px
    @media screen and (min-width: 1024px)
      padding: 20px
      font-size: 16px
    @media screen and (max-width: 1024px)
      padding: 10px
      font-size: 16px

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus
  -webkit-transition-delay: 9999s !important
  transition-delay: 9999s !important
  color: #626C85 !important
  -webkit-text-fill-color: #626C85 !important
</style>
